export const theme: { [key: string]: string } = {
  black: '#000000',
  dark: '#34365C',
  darkText: '#878787',
  darklight: '#3b3d67',
  darkgray: '#707070',
  lightblue: '#dedee8',
  darkblue: '#1C2260',
  gray: '#DBDBDB',
  lightGray: '#d9d9d9',
  thDark: '#8A8686',
  lightGreen: '#72F5B0',
  green: '#74F7E7',
  borderDark: '#1a1f4a',
  focusWhite: '#f8f9ff',
  superDark: '#0f1124',
  darkModal: 'rgb(15, 17, 36, 0.5)',
  white: '#FEFEFE',
  lightBlueGrey: '#c3c6e0',
  steel: '#707394',
  lightNavyBlue: '#323b88',
  cloudyBlue: '#acafd2',
  lightPaleGrey: 'rgba(234, 236, 255, 0.3)',
  paleGrey: '#eaecff',
  paleGrey2: '#f4f6fe',
  pageGrey3: '#f3f7ff',
  royal: '#272C3F',
  sapphire: '#2a37ae',
  greenBlue: '#00c078',
  azul: '#2652ed',
  lightAzul: 'rgba(38, 82, 237, 0.2)',
  blueBlue: '#243dc3',
  ice: '#e6faf2',
  coral: '#fa5a53',
  veryLightPink: '#ffe8e8',
  veryLightPink2: '#b8b8b8',
  veryLightPink3: '#e4e4e4',
  gdLightDark: '#0f1124',
  gdDark: '#1c1f3a',
  tableHeader: '#DDDEE7',
  tableHeaderText: '#8A8686',
  tableBorder: '#F3F5FF',
  error: 'red',
  blueLogin: '#023ba8',
  statusActive: '#E8FFF3',
  statusActiveText: '#52CE8F',
  statusInviting: '#F9F3F8',
  statusInvitingText: '#B2609C',
  statusReserve: '#FEFAF3',
  statusReserveText: '#F6BB56',
  statusInActive: '#D9D9D9',
  statusInActiveText: '#727572',
  statusDeleted: '#707070',
  statusDeletedText: '#E8E8E8',
  ggBackground: '#F1EEEE',
  errorBackground: '#FA767630',
  mediumPassword: '#FFD940',
  wnn_working_mark: '#0FE41D',
  wnn_full_mark: '#E4CF0F',
  wnn_inactive_mark: '#969696',
  wnn_bg_green: '#BFFFC3',
  wnn_text_green: '#0FE41D',
  wnn_bg_yellow: '#FFFDE2',
  wnn_text_yellow: '#E4CF0F',
  wnn_bg_purple: '#FFDFFF',
  wnn_text_purple: '#9702A8',
  wnn_bg_red: '#FFDFE9',
  wnn_text_red: '#EB1A1A',
  wnn_bg_blue: '#DFEAFF',
  wnn_text_blue: '#023BA8',
  wnn_bg_orange: '#FFE7BF',
  wnn_text_orange: '#E4AC0F',
  wnn_bg_gray: '#D9D9D9',
  wnn_text_gray: '#727572',
  wnn_bg_lightBlue: '#D5F9FD',
  wnn_bg_yellowgreen: '#c3fa43',
  wnn_text_lightBlue: '#0FD9D3',
  wnn_text_yellowgreen: '#9ab802',
  wnn_bg_brown: '#F5EDE4',
  wnn_text_brown: '#BD853B',
  wnn_text_green_stationnumber: '#BFFFC3',
  wnn_alert: '#B22727',
};

export default theme;
